import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ProductSliderV5 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL + '/'

        return <div className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-115 pb-70" data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center---">
                            <h2 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Completed Projects</h2>
                            {/* <h1 className="section-title">Find Your Dream Residential Plots</h1> */}
                        </div>
                    </div>
                </div>
                <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                    <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                            <div className="search-by-place-img">
                                <Link to="/completed"><img src={publicUrl + "assets/img/projects/KKR City/img1.jpg"} alt="#" /></Link>
                                {/* <div className="search-by-place-badge">
                                    <ul>
                                        <li>No of plot: 58</li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="search-by-place-info">
                                <h6><Link to="/completed">Chennai</Link></h6>
                                <h4><Link to="/completed">KKR City</Link></h4>
                                <div className="search-by-place-btn">
                                    <Link to="/completed">View Projects <i className="flaticon-right-arrow" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                            <div className="search-by-place-img">
                                <Link to="/completed"><img src={publicUrl + "assets/img/projects/Krishna Nagar/img1.jpg"} alt="#" /></Link>
                                {/* <div className="search-by-place-badge">
                                    <ul>
                                        <li>No of plots:4</li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="search-by-place-info">
                                <h6><Link to="/completed">Navallur</Link></h6>
                                <h4><Link to="/completed">Krishna Nagar</Link></h4>
                                <div className="search-by-place-btn">
                                    <Link to="/completed">View Projects <i className="flaticon-right-arrow" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                            <div className="search-by-place-img">
                                <Link to="/completed"><img src={publicUrl + "assets/img/projects/Manimozhi nagar/img1.jpg"} alt="#" /></Link>
                                {/* <div className="search-by-place-badge">
                                    <ul>
                                        <li>No of plot:10</li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="search-by-place-info">
                                <h6><Link to="/completed">Naduveera Pattu</Link></h6>
                                <h4><Link to="/completed">Manimozhi Nagar</Link></h4>
                                <div className="search-by-place-btn">
                                    <Link to="/completed">View Projects <i className="flaticon-right-arrow" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default ProductSliderV5